﻿import toastr from 'toastr';

export default class NotificationsHelper {
    constructor() {
        this.errorCollection = [];
        this.warningCollection = [];
        this.successCollection = [];
    }

    addError(message) {
        var thisClass = this;

        thisClass.errorCollection.push(message);
        thisClass._showErrors();
    }

    showError(message) {
        var thisClass = this;

        thisClass.errorCollection.push(message);
        thisClass._showErrors();
    }

    addErrors(messages) {
        var thisClass = this;

        for (var i = 0; i < messages.length; i++) {
            thisClass.errorCollection.push(messages[i]);
        }
    }

    addErrorResult(result) {
        if (result === null || result === undefined)
            return;

        var thisClass = this;

        for (var i = 0; i < result.errors.length; i++) {
            thisClass.addError(result.errors[i].errorMessage);
        }
    }

    addWarning(message) {
        var thisClass = this;

        thisClass.warningCollection.push(message);
    }

    addWarnings(messages) {
        var thisClass = this;

        for (var i = 0; i < messages.length; i++) {
            thisClass.warningCollection.push(messages[i]);
        }
    }

    addSuccess(message) {
        var thisClass = this;

        thisClass.successCollection.push(message);
    }

    showSuccess(message) {
        var thisClass = this;

        thisClass.successCollection.push(message);
        thisClass._showSuccesses();
    }

    addSuccesses(messages) {
        var thisClass = this;

        if (messages.isArray()) {

            for (var i = 0; i < messages.length; i++) {
                thisClass.successCollection.push(messages[i]);
            }
        }
    }


    _showErrors() {
        var thisClass = this;

        for (var i = 0; i < thisClass.errorCollection.length; i++) {
            toastr.error(thisClass.errorCollection[i]);
        }

        //clear array
        thisClass.errorCollection = [];
    }

    _showWarnings() {
        var thisClass = this;

        for (var i = 0; i < thisClass.warningCollection.length; i++) {
            toastr.warning(thisClass.warningCollection[i]);
        }

        //clear array
        thisClass.warningCollection = [];
    }

    _showSuccesses() {
        var thisClass = this;

        for (var i = 0; i < thisClass.successCollection.length; i++) {
            toastr.success(thisClass.successCollection[i]);
        }

        //clear array
        thisClass.successCollection = [];
    }

    showNotifications() {
        var thisClass = this;

        thisClass._showSuccesses();
        thisClass._showWarnings();
        thisClass._showErrors();
    }
}